
import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { BookOpen } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <motion.footer
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5, delay: 0.2 }}
      className="bg-card border-t border-border py-8 text-center"
    >
      <div className="container mx-auto px-4">
        <div className="flex justify-center mb-3">
          <Link
            to="/manual"
            className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-primary transition-colors"
          >
            <BookOpen className="h-4 w-4" />
            Manual de usuario
          </Link>
        </div>
        <p className="text-sm text-muted-foreground">
          &copy; {currentYear} OptyLav . Todos los derechos reservados.
        </p>
        <p className="text-xs text-muted-foreground/70 mt-1">
          Desarrollado por DLTausa
        </p>
      </div>
    </motion.footer>
  );
};

export default Footer;
  